import api from '@/api/payout';

export default {
  namespaced: true,
  state: () => ({
    items: null,
  }),
  getters: {},
  mutations: {
    setItems(state, items) { state.items = items; },
  },
  actions: {
    fetch({ commit }) {
      api.fetchList([], true)
        .then((r) => { commit('setItems', r.items); });
    },
  },
};
